import React from "react";
import AssignmentMarkList from "../../components/Dashboard/AssignmentMark/AssignmentMarkList";
import AssignmentStatus from "../../components/Dashboard/AssignmentMark/AssignmentStatus";
import Navbar from "../../components/Navbar";

export default function AssignmentMark() {
  return (
    <>
      <Navbar />

      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <div className="px-3 py-20 bg-opacity-10">
            <AssignmentStatus />

            <AssignmentMarkList />
          </div>
        </div>
      </section>
    </>
  );
}
